// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"8eb9c0bf","134":"cf3a857c","250":"ec1307e3","314":"5264c083","349":"87498a04","499":"1936c48f","501":"afb487c7","566":"874951ae","879":"ad23814f","908":"2786b2e6","951":"d37656cc","955":"e314292c"}[chunkId] + ".chunk.js";
};